// src/api/auth.js
import { instance , noTokenInstance } from './index';
// // 注册用户
export const registerUser = async (data) => {
  try {
    const response = await instance.post('/web/api/general-login/sms-appRegister', data);
    return response;
  } catch (error) {
    console.error('注册失败:', error);
    throw error;
  }
};


// 获取验证码
export const getsmsCode = async (phoneNo) => {
  try {
    const response = await noTokenInstance.post('/web/api/sms-captcha/reg', { phoneNo });
    return response;
  } catch (error) {
    console.error('验证码发送失败:', error);
    throw error;
  }
};

// const instance = axios.create({
//   baseURL: process.env.VUE_APP_BASE_API,
//   // 其他配置...
// });

// export function registerUser(data) {
//   return instance.post('/general-login/sms-appRegister', data);
// }

// export function getsmsCode(data) {
//   return noTokenInstance.post('/sms-captcha/login', {'phoneNo':data});
// }